import { IProgram } from "../../../domain/core/entities/programEntity";
import ProgramFirebase from "../../../infrastructure/datasources/program/firebase/programFirebase";

export default class ProgramUseCase {
  private _repository: ProgramFirebase = new ProgramFirebase();

  async getPrograms(obj: { start?: string; isNext?: string; isPrevious?: string; limit?: number; }): Promise<IProgram[]> {
    try {
      const response = await this._repository.getPrograms({start: obj.start, isNext: obj.isNext, isPrevious: obj.isPrevious, limit: obj.limit });

      if ('code' in response) throw response;

      return response;
    } catch (error) {
      throw error;
    }
  }

  async getProgramsByQuery(obj: { start?: string; isNext?: string; isPrevious?: string; limit?: number; searchQuery: string }): Promise<IProgram[]> {
    try {
      const response = await this._repository.getProgramsByQuery({start: obj.start, isNext: obj.isNext, isPrevious: obj.isPrevious, limit: obj.limit, searchQuery: obj.searchQuery });

      if ('code' in response) throw response;

      return response;
    } catch (error) {
      throw error;
    }
  }

  async getProgramById(programId: string): Promise<IProgram> {
    try {
      const response = await this._repository.getProgramById(programId);

      if ('code' in response) throw response;

      return response;
    } catch (error) {
      throw error;
    }
  }

  async createProgram(program: IProgram): Promise<IProgram> {
    try {
      const response = await this._repository.createProgram(program);

      if ('code' in response) throw response;

      return response;
    } catch (error) {
      throw error;
    }
  }

  async createProgramWithExcel(programs: IProgram[]): Promise<boolean> {
    try {
      const response = await this._repository.createProgramsWithExcel(programs);

      if (typeof response !== "boolean") throw response;

      return response;
    } catch (error) {
      throw error;
    }
  }

  async editProgram(program: IProgram): Promise<IProgram> {
    try {
      const response = await this._repository.editProgram(program);

      if ('code' in response) throw response;

      return response;
    } catch (error) {
      throw error;
    }
  }

  async deleteProgram(programId: string): Promise<string> {
    try {
      const response = await this._repository.deleteProgram(programId);

      if (typeof response !== "string") throw response;

      return response;
    } catch (error) {
      throw error;
    }
  }

  async editProgramStatus(programId: string, status: string): Promise<string> {
    try {
      const response = await this._repository.editProgramStatus(programId, status);

      if (typeof response !== "string") throw response;

      return response;
    } catch (error) {
      throw error;
    }
  }
}
